export default "__VITE_ASSET__b3f9510a__"